import React, { FC, useState } from "react";
import {
  InputDateTime,
  InputNumber,
  InputSelect,
  InputText,
} from "../../../../components/input";

import {
  IInputArrayFormProps,
  IInputArrayDataStructureItem,
} from "../../../../components/input/arrayData";
import { CreateNotification } from "../../../../components/notifier";
import {
  convertToDate,
  getDay,
  getDDMMYYYFormat,
  getDiffDay,
  getLocalDate,
} from "../../../../helper/dateTimeHelper";
import { Button } from "../../../../modules/button";
import { InputWraper, useForm } from "../../../../modules/form";
import { ObjectUtils } from "../../../../modules/utils";

export const DemandForSuppliesContentStructure: IInputArrayDataStructureItem[] =
  [
    {
      name: "Content",
      label: "Nội dung",
      isVisibleOnList: true,
    },
    {
      name: "Unit",
      label: "Đơn vị tính",
      isVisibleOnList: true,
    },
    {
      name: "SuggestedQuantity",
      label: "Số lượng đề nghị",
      isVisibleOnList: true,
    },
    {
      name: "EstimatedTimeOfUse",
      label: "Thời gian dự kiến sử dụng",
      isVisibleOnList: true,
    },
    {
      name: "Notes",
      label: "Ghi chú/Giải trình",
      isVisibleOnList: true,
    },
  ];

export const DemandForSuppliesContentForm: FC<IInputArrayFormProps> = (props) => {
  const { childFormData } = props;
  const today = new Date();
  const UnitSelections = ["Bộ", "Cái", "Chiếc", "Cục", "Hộp", "Cuộn", "met", "met2", "Tấm", "Cây"];
  const [unitSelected, setUnitSelected] = useState(null as any);
  const [estimatedTimeOfUse, setEstimatedTimeOfUse] = useState(childFormData?.EstimatedTimeOfUse ? new Date(convertToDate(childFormData?.EstimatedTimeOfUse)) : today);
  const { handleSubmit, getInputProps } = useForm({
    structure: props.structure.map((item) => {
      return {
        ...item,
        defaultValue:
          ObjectUtils.getIn(childFormData, item.name) || item.defaultValue,
      };
    }),
    onSubmit: (values) => {
      values.Unit = unitSelected ? unitSelected : values.Unit;
      if (
        !values.Content ||
        !values.SuggestedQuantity ||
        !values.Unit ||
        !values.Notes
      )
        CreateNotification({
          title: "Thông báo",
          body: "Vui lòng nhập đầy đủ thông tin yêu cầu!",
          icon: "/icons/warning.png",
        });
      else
        values.EstimatedTimeOfUse = getDDMMYYYFormat(
          getDay(estimatedTimeOfUse)
        );
      props.onSubmit(values);
    },
  });

  const onUnitChange = (e: any) => {
    setUnitSelected(e.value);
  };

  const onEstimatedTimeOfUseChange = (date: any) => {
    const newDate = new Date(date);
    setEstimatedTimeOfUse(newDate);
    const days = getDiffDay(
      getLocalDate(newDate),
      getLocalDate(getDay(estimatedTimeOfUse))
    );
    if (days < 0) {
      setEstimatedTimeOfUse(newDate);
    }
  };

  // useEffect(() => {
  //   if (employees) {
  //     if (childFormData && childFormData.staffCode) {
  //       setEmployeesSelected(
  //         employees.find((o: any) => o.eEmployeeId === childFormData.staffCode)
  //           .eMail
  //       );
  //     } else {
  //       setEmployeesSelected(employees[0].eMail);
  //       setEmployeesCode(employees[0].eEmployeeId);
  //     }
  //   }
  // }, [employees]);

  return (
    <div className="Form__add-demandForSupplies py-3">
      <h6>
        ( <span className="star_content">*</span> ): Trường thông tin bắt buộc
        phải nhập{" "}
      </h6>

      <InputWraper
        inputProps={getInputProps("Content")}
        renderInput={(s) => <InputText {...s} />}
        isRequired
      />

      <InputWraper
        inputProps={getInputProps("Unit")}
        renderInput={(s) => (
          <InputSelect
            {...s}
            options={UnitSelections.map((e: any) => ({ label: e, value: e }))}
            onChange={onUnitChange}
            value={unitSelected ? unitSelected : s.value}
            placeholder="* Vui lòng chọn đơn vị tính"
          />
        )}
        isRequired
      />

      <InputWraper
        inputProps={getInputProps("SuggestedQuantity")}
        renderInput={(s) => <InputNumber {...s} />}
        isRequired
      />

      <InputWraper
        inputProps={getInputProps("EstimatedTimeOfUse")}
        renderInput={(s) => (
          <>
            <InputDateTime
              {...s}
              value={estimatedTimeOfUse}
              onChange={onEstimatedTimeOfUseChange}
            />
          </>
        )}
        isRequired
        className="estimatedTimeOfUse"
      />

      <InputWraper
        inputProps={getInputProps("Notes")}
        renderInput={(s) => <InputText {...s} />}
        isRequired
      />

      <div className="foot">
        <Button type="button" label="Xác nhận" onClick={handleSubmit} />
      </div>
    </div>
  );
};
